import { RouteComponentProps } from "react-router";

export const languages = ["en","es","fr","zh","my"];

export interface CardProps{
    fondo: string;
    nombre: string;
}

export interface MenuSitios{
  title:string;
  loc:string;
  rank:number;
  cantrw:number;
  prec:number;
  img:string;
}

export interface ContainerProps {
  onFinish: () => void;
}

export interface RestaurantProps{
  nombre: string,
  direccion:string, 
  imageUrl: string, 
  calificacion: number, 
  open: string
}

export interface FoodItemsProps {
  nombre: string, 
  descripcion:string, 
  ingredientes: object[],
  urlimagen: string,
  nombreIngrediente: string[],
  imageIngrediente: string[],
  estatusEndemico: boolean[],
  descripcionEndemico: string[]
  // beneficios: string[]
}

export interface Marcador {
  id: string,
  nombreEstacion?: string,
  nombrePolo?: string,
    descripcion: string,
    lat: number,
    lng: number,
		telefono: string,
		direccion: string,
		horarios?: string,
		sitioweb: string,
    image1?: string,
		categoria?: number,
		tramo?: number,
    polo?: number
    imagenes?:{
      id: string,
      idMedia: string,
      nombreEstacion: string,
      tamano: string,
      url: string
    }[]
    images?: string[]
}

export interface ParaderoTrenMaya {
  id: string,
  nombreEstacion: string,
  nombre: string,
  localidad: string,
  icono: string,
  descripcion: string,
  lat: number,
  lng: number,
  telefono: string,
  direccion: string,
  horarios: string,
  sitio_web: string,
  image1: string,
  images: string[],
  categoria: number,
  tramo: number,
  accesibilidad: string,
  instalaciones: string,
  horarios_de_trenes: string
}

export interface infraestructura {
  cercania_ferrocarril: boolean,
  puerto: string,
  aeropuerto: string,
  vialidades: string[],
  energia: string,
  agua: string,
  drenaje: string

}

export interface PolosDesarrollo {
  id: string,
  nombre: string,
  estado: string,
  municipio: string,
  latitud: number,
  longitud: number,
  superficie_ha: string,
  vocacion_productiva: string[],
  infraestructura: infraestructura,
  estado_desarrollo: string,
  poblacion_beneficiaria: number,
  inversiones_privadas: [],
  empleos_estimados: number,
  organismo_responsable: string,
  sitio_web: string,
  correo: string,
  images: string[]
  descripcion: string
}

export interface ArtesaniasProps {
  nombrePieza?: string,
  nombreAutor: string,
  localidad: string,
  descripcion: string,
  historia: string,
  proceso: string,
  precio: number,
  urlImg: string
}

export interface ToursProps {
  estacion: string,
  titulo: string,
  imgPortada: string,
  precio: number,
  sitioWeb: string,
  actividades: string[],
  imgActividades: string[],
  telefono: string,
  incluye: string[]
}

export interface TurComProps {
  id: string
  nombre: string,
  empresa: string,
  localidad: string,
  estado: string,
  titulo: string,
  programa: string,
  latitud: number,
  longitud: number,
  heroImage: string,
  sitioWeb: string,
  descripcion: string,
  actividades: string[],
  imagenes: string[],
  datos_contacto: string[],
  incluye: string[]
}

export interface HospedajeProps {
  nombre: string,
  direccion: string,
  telefono: string,
  precio: string,
  urlImage: string,
  resena: string,
  calificacion: number,
  incluye: string [],
  imgActividades: string[]
}

export interface ArqProps {
  nombre: string,
  traduccion: string,
  municipio: string,
  descripcion: string,
  horario: string,
  sitio_web: string,
  precio: number,
  tipo: string
  urlImage: string,
  promocion: string,
}

export interface MuseoProps {
  nombre: string,
  traduccion?:string,
  municipio: string,
  latitud?: string,
  longitud?: string,
  descripcion: string,
  horario: string,
  sitio_web: string,
  precio: any,
  tipo: string
  urlImagen: string[],
  promocion: string,
}

export interface BancoProps {
  nombre: string,
  traduccion?:string,
  municipio: string,
  latitud?: string,
  longitud?: string,
  descripcion: string,
  horario: string,
  sitio_web: string,
  tipo: string
  urlImagen: string[]
}

export interface ZonaArqProps {
  nombre: string,
  traduccion?:string,
  municipio: string,
  latitud?: string,
  longitud?: string,
  descripcion: string,
  horario: string,
  sitio_web: string,
  tipo: string
  urlImagen: string[]
}

export interface SitiosArqProps {
  nombre: string,
  traduccion?:string,
  municipio: string,
  latitud?: string,
  longitud?: string,
  descripcion: string,
  horario: string,
  sitio_web: string,
  precio: number,
  tipo: string,
  promocion: string,
  urlImagen: string[],
  duracion_visita: string,
  cronologia: string,
  func_original: string,
  mitos: string,
  eventos_historicos: string,
  descubrimiento: string,
  estructuras_iconicas: string,
  rutas_sugeridas: string,
  colecciones_destacadas: string,
  accesibilidad: string,
  instalaciones: string,
  recomendaciones: string,
  reconocimientos: string
}


export interface PuebloMagicoProps {
  nombre: string,
  traduccion?:string,
  municipio: string,
  latitud?: string,
  longitud?: string,
  descripcion: string,
  horario: string,
  sitio_web: string,
  tipo: string
  urlImagen: string[]
}

export interface ZonaRestProps {
  nombre: string,
  traduccion?:string,
  municipio: string,
  latitud?: string,
  longitud?: string,
  descripcion: string,
  horario: string,
  sitio_web: string,
  tipo: string
  urlImagen: string[]
}

export interface ZonaCoopProps {
  nombre: string,
  traduccion?:string,
  municipio: string,
  latitud?: string,
  longitud?: string,
  descripcion: string,
  horario: string,
  sitio_web: string,
  tipo: string
  urlImagen: string[]
}

export interface Tipo
  extends RouteComponentProps<{
    nom: string;
  }>{nom: string}

  export interface infoexpyuc{
    label: string,
    values: string[]
  }
  export interface infodisyuc{
    label: string,
    values: string
  }
  export interface infoactyuc{
    text: string,
    url: string
  }

  export interface infocooyuc{
    latitud: number,
    longitud: number
  }

  export interface ExpYucatanProps {
    id: number,
    lugar: string,
    nombre: string,
    imagen_prin: string,
    nombre_corto: string,
    informacion: infoexpyuc[],
    regiones: string,
    imagenes: string[],
    descripcion: string,
    actividades: infoactyuc[],
    distancias: infodisyuc[],
    sugerido_para: string,
    latitud: number,
    longitud: number
  }

  export interface SabYucatanProps {
    id: number,
    lugar: string,
    nombre: string,
    imagen_prin: string,
    nombre_corto: string,
    informacion: infoexpyuc[],
    descripcion: string,
    regiones: string,
    datos_interes: infoexpyuc[],
    imagenes: string[],
    distancias: infodisyuc[],
    latitud: number,
    longitud: number
  }

  export interface PMagicoProps {
    nombre: string,
    traduccion: string,
    municipio: string,
    latitud: string,
    longitud: string,
    descripcion: string,
    horario: string,
    sitio_web: string,
    precio: number,
    tipo: string,
    promocion : string,
    urlImagen: string[],
    caracteristicas: string,
    atractivos: string[],
    festividades: string[],
    ubicacion: string
  }

  export interface PlatilloQRooProps {
    nombrePlatillo: string,
    chef: string,
    localidad: string,
    estado: string,
    latitud: string,
    longitud: string,
    descripcion: string[],
    imagenPlatillo: string[],
    ingredientes: string[],
    imagenesIngredientes: string[],
    procedimiento: string[]
  }

  export interface ArtesaniaProps {
    nombre: string,
    descripcion: string,
    materiales: string[],
    imagenes: string[],
    estado: string,
    municipio: string,
    artesano: string,
    latitud: number,
    longitud: number,
    datosinteres: string
  }

  export interface CreadoMexicoProps {
    nombre: string,
    descripcion: string,
    imagenes: string[],
    latitud: number,
    longitud: number,
    estado: string,
    municipio: string
  }
